export default __webpack_public_path__ + "static/media/Right Hero.19a4c7f4.png";